import UserService from '@/common/api/user'
import {
  USER_REGISTRATION,
  UPDATE_USER_PROFILE,
  GET_USER_MAIL,
  UPDATE_USER_MAIL,
  GET_USER_MAIL_CHANGE_ADDRESS,
  USER_LOGIN
} from './actions'
import {
  FETCH_USER
} from './mutations'

const state = {
  createUser: {},
  userPoint: {}
}

const getters = {
  createUser (state) {
    return state.createUser
  },
  getUserPoint (state) {
    return state.userPoint
  }
}

const actions = {
  [USER_REGISTRATION] (context, params = {}) {
    return new Promise((resolve, reject) => {
      UserService.post(params)
        .then(({ data }) => {
          context.commit(FETCH_USER, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_USER, null)
          reject(error)
        })
    })
  },
  [UPDATE_USER_PROFILE] (context, params = {}) {
    return new Promise((resolve, reject) => {
      UserService.updateProfile(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_USER_MAIL_CHANGE_ADDRESS] (context, params = {}) {
    return new Promise((resolve, reject) => {
      UserService.getMailChangeAddress(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_USER_MAIL] (context, params = {}) {
    return new Promise((resolve, reject) => {
      UserService.getMail(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [UPDATE_USER_MAIL] (context, params = {}) {
    return new Promise((resolve, reject) => {
      UserService.updateMail(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [USER_LOGIN] (context, params = {}) {
    return new Promise((resolve, reject) => {
      UserService.login(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  [FETCH_USER] (state, data) {
    state.createUser = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
